import React, { useEffect, useRef } from 'react';
import './Clients.css';

const Clients = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = sectionRef.current?.querySelectorAll('.fade-in');
    elements?.forEach((element) => observer.observe(element));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="clients section-padding" ref={sectionRef}>
      <div className="container">
        <div className="section-header text-center">
          <h2 className="fade-in">Watch Our Craft</h2>
          <p className="section-subtitle fade-in">
            See the artistry and heritage behind every piece<br />
            we create in Jezzine, Lebanon
          </p>
        </div>

        <div className="video-wrapper fade-in">
          <iframe
            src="https://www.youtube.com/embed/dLyz2FIhByc"
            title="Chahine Cutlery — Our Craft"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        </div>
      </div>
    </section>
  );
};

export default Clients;
